export const COMMIT_SHA = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA;
export const DEPLOYMENT_URL = process.env.NEXT_PUBLIC_VERCEL_URL;
export const GOOGLE_MAPS_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
export const MAP_BOX_TOKEN = process.env.NEXT_PUBLIC_MAP_BOX_TOKEN;

export const SLACK_WEBHOOK_URL = process.env.SLACK_WEBHOOK_URL;

export const PUBLIC_ROUTES = ['/authentication/sign-up', '/authentication/sign-in', '/authentication/link-sent'];

export const TRANSITION_ROUTES = ['/auth', '/logout'];
export const DOCS_SITE_LOGIN_ROUTE = '/authentication/docs';
// The popup an OAuth provider sends the user back to after authorizing an MCP server. It posts
// MCP_OAUTH_MESSAGE_TYPE with the saved server to the dashboard window that opened it.
export const MCP_OAUTH_CALLBACK_ROUTE = '/agents/mcp-oauth/callback';
export const MCP_OAUTH_MESSAGE_TYPE = 'footprint:mcp-oauth-complete';
export const DEFAULT_PUBLIC_ROUTE = '/ask-percy';
export const DEFAULT_PRIVATE_ROUTE = '/authentication/sign-in';
export const DASHBOARD_AUTHORIZATION_HEADER = 'x-fp-dashboard-authorization';
export const DASHBOARD_IS_LIVE_HEADER = 'x-is-live';
export const DASHBOARD_ALLOW_ASSUMED_WRITES = 'x-allow-assumed-writes';
export const MAIN_PAGE_ID = 'page-main';
export const HOME_ROUTES = ['/ask-percy', '/'];
export const RSG_SHORTCUT_KEYS = ['meta', '/'];

// Auditor roles may only reach the entity tabs (and their detail/sub-routes). Single source of truth
// shared by the side-nav visibility filter (`use-routes`) and the route guard (`use-auditor-route-guard`).
export const AUDITOR_HOME_ROUTE = '/users';
export const AUDITOR_ALLOWED_ROUTES = [AUDITOR_HOME_ROUTE, '/businesses', '/authentication/mcp'];

// Percy chat routes. The `*_ROUTE` values are the Next.js `router.pathname` form
// (with `[param]`) for matching; the `*_PARAM` values are their dynamic-segment
// query keys; the `*Url` builders produce concrete hrefs for navigation.
export const ASK_PERCY_ROUTE = '/ask-percy';
export const CHAT_SESSION_ROUTE = '/chat/[workflowId]';
export const INVESTIGATION_ROUTE = '/investigations/[investigationId]';
export const CHAT_SESSION_PARAM = 'workflowId';
export const INVESTIGATION_PARAM = 'investigationId';
// Query param carrying the chat session shown on an investigation, so the chosen
// chat (e.g. the Ask Percy session that opened it) survives a reload.
export const INVESTIGATION_CHAT_PARAM = 'chat';
// Query param selecting the artifact shown on an investigation detail page.
export const INVESTIGATION_ARTIFACT_PARAM = 'artifact';
export const chatSessionUrl = (id: string) => `/chat/${id}`;
export const investigationUrl = (id: string, opts?: { artifactId?: string; chatSessionId?: string }) => {
  const query = new URLSearchParams();
  if (opts?.artifactId) query.set(INVESTIGATION_ARTIFACT_PARAM, opts.artifactId);
  if (opts?.chatSessionId) query.set(INVESTIGATION_CHAT_PARAM, opts.chatSessionId);
  const qs = query.toString();
  return qs ? `/investigations/${id}?${qs}` : `/investigations/${id}`;
};
export const AGENT_BUILDER_ROUTE = '/agents/[id]/builder';
// `?chat=` carries the chat shown on the builder (mirrors the investigation flow).
// `?versionId=` deep-links to a specific agent version (the builder opens it in historical preview);
// `?tab=changes` opens the builder's Changes panel (from a "Percy proposed N changes" card).
export const agentBuilderUrl = (
  agentId: string,
  opts?: { chatSessionId?: string; versionId?: string; tab?: 'changes' },
) => {
  const query = new URLSearchParams({ mode: 'edit' });
  if (opts?.chatSessionId) query.set(INVESTIGATION_CHAT_PARAM, opts.chatSessionId);
  if (opts?.versionId) query.set('versionId', opts.versionId);
  if (opts?.tab) query.set('tab', opts.tab);
  return `/agents/${agentId}/builder?${query.toString()}`;
};
export const PLAYBOOKS_ROUTE = '/playbooks';
export const PLAYBOOK_ROUTE = '/playbooks/[id]';
// Query param that opens the editor on Percy's open draft session.
export const PLAYBOOK_EDIT_SESSION_PARAM = 'editSessionId';
export const playbookUrl = (
  id: string,
  opts?: { editSessionId?: string | null; chatSessionId?: string; version?: string | null },
) => {
  const query = new URLSearchParams();
  if (opts?.editSessionId) query.set(PLAYBOOK_EDIT_SESSION_PARAM, opts.editSessionId);
  if (opts?.version) query.set('version', opts.version);
  if (opts?.chatSessionId) query.set(INVESTIGATION_CHAT_PARAM, opts.chatSessionId);
  const qs = query.toString();
  return qs ? `/playbooks/${id}?${qs}` : `/playbooks/${id}`;
};
